// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Empty/Doctor/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_DentalMonitoring_Empty_Doctor($parent_company_id: uuid!) {
  dental_monitoring_doctors(
    where: { parent_company_id: { _eq: $parent_company_id } }
  ) {
    id
    user {
      id
      vaxiom_person {
        id
        first_name
        last_name
      }
    }
  }
}

`